import { Injectable, Inject } from '@angular/core';
import { HttpModule, Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { APP_CONFIG, IAppConfig } from './../app.config';
import 'rxjs/add/observable/throw';

@Injectable()

export class CareerInfoService {

  private _token:string = localStorage.getItem('token');
  
  constructor(
    private http: Http,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  postCareerInfo$(info: any): Observable<any> {
    let token = this._token;
    const headers = new Headers({ 'Content-Type': 'application/json','Authorization': token});
    return this.http.post(this.config.apiEndpoint + 'carrerinfo/add-career-information', info, {
        headers: headers
      })
      .catch(this.handleErrorObservable);
  }

  getCareerInfo(info: any): Observable<any>{

    let headers = new Headers({ 'Authorization': this._token });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.config.apiEndpoint +'carrerinfo/get-career-information', info, options)
      .map((res: Response) => res.json()) // ...and calling .json() on the response to return data
    .catch(this.handleErrorObservable); // ...errors if any

  }

    academicMajorList() {
        let token = this._token;
        let headers = new Headers({ 'Authorization': token });
        let options = new RequestOptions({ headers: headers });

        return this.http.get(this.config.apiEndpoint + 'carrerinfo/get-academic-major', options).map((res => res.json()))
            .catch(this.handleErrorObservable);
    }

    professionalGoalsList() {
        let token = this._token;
        let headers = new Headers({ 'Authorization': token });
        let options = new RequestOptions({ headers: headers });

        return this.http.get(this.config.apiEndpoint + 'carrerinfo/get-professional-goals', options).map((res => res.json()))
            .catch(this.handleErrorObservable);
    }

  private handleErrorObservable (error: Response | any) {
    /*if(!error.json().error){
      alert('Please check your internet connection');
    }*/
    return Observable.throw( error.json().error || 'Server Error' );
  }
 
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/career-info.service.ts